import actions from "actions";
import InputField from "components/InputField/InputField.jsx";
import Pagination from "components/Pagination/TablePagination";
import constants from "constants";
import { IconButton, Menu, MenuItem } from "material-ui";
import MoreVertIcon from "material-ui-icons/MoreVert";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { validate } from "validate.js";
import { sortExpertsByNumeration } from "utils/sort-experts";

const { getStudyGroupWebinars, showDeleteGroupWebinarsConfirmationModal } =
  actions;

const { CPD_STATUSES } = constants;

const headers = [
  { label: "START DATE/TIME", value: "created_at" },
  { label: "TITLE", value: "webinar_title" },
  { label: "EXPERT NAME", value: null },
  { label: "CPD", value: null },
  { label: "CPD POINTS", value: null },
  { label: "CPD QUIZ", value: null },
  { label: "SPONSOR", value: null },
  { label: "STATUS", value: null },
  { label: "", value: null },
];

class StudyGroupSuperhostWebinars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      page: 1,
      per_page: 50,
      title: "",
      order: "",
    };
  }

  getParams = () => {
    const { selected, ...rest } = this.state;
    const { id: group_id } = this.props.params;

    return { ...rest, group_id };
  };

  componentDidMount() {
    this.props.getStudyGroupWebinars(this.getParams());
  }

  handleSelectItem = (id) => {
    this.state.selected.includes(id)
      ? this.setState((prev) => ({
          selected: prev.selected.filter((value) => value !== id),
        }))
      : this.setState((prev) => ({ selected: [...prev.selected, id] }));
  };

  handleDelete = (id) => {
    this.props.deleteWebinars([id], this.getParams());
  };

  onChangePage = (page) =>
    this.setState({ page }, () =>
      this.props.getStudyGroupWebinars(this.getParams())
    );

  handleQueryChange = (title, timeout = 500) => {
    this.setState({ title }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(
        () => this.props.getStudyGroupWebinars(this.getParams()),
        timeout
      );
    });
  };

  handleOrderChange = (order) =>
    this.setState({ order }, () =>
      this.props.getStudyGroupWebinars(this.getParams())
    );

  render() {
    const {
      groupWebinars: { data, totalPages },
      params: { id },
      user,
    } = this.props;

    const { selected, page, title } = this.state;

    const canUserCanEdit = (webinar) =>
      Boolean(webinar.superhost) && webinar.superhost.id === user.id;

    return (
      <div style={{ width: "90%", margin: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
            marginBottom: "16px",
          }}
        >
          <div className="container_admin_user">
            <div className="search_admin">
              <input id="search" type="submit" className="validate" />
              <label htmlFor="search">
                <i className="material-icons icon_search">search</i>
              </label>
              <input
                type="search"
                placeholder="Search"
                value={title}
                onChange={(e) => this.handleQueryChange(e.target.value)}
              />
              <i
                className="material-icons icon_close"
                onClick={() => this.handleQueryChange("")}
              >
                close
              </i>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <Link to={`/groups/${id}/webinars/new`}>
                <button className="button_link">Create New Meeting</button>
              </Link>
              <Link to={`/groups/${id}/webinars/upcoming`}>
                <button className="button_link">View Dashboard</button>
              </Link>
            </div>
          </div>
        </div>

        <div style={{ width: "100%", overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                {headers.map(({ label, value }, idx) => (
                  <th
                    key={idx}
                    onClick={
                      value ? () => this.handleOrderChange(value) : undefined
                    }
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((webinar) => (
                <Webinar
                  webinar={webinar}
                  key={webinar.id}
                  handleDelete={() => this.handleDelete(webinar.id)}
                  groupId={id}
                  canUserCanEdit={canUserCanEdit(webinar)}
                />
              ))}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          onChangePage={this.onChangePage}
          total_pages={totalPages}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  groupWebinars: state.studygroups.webinars,
  user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({
  getStudyGroupWebinars: (payload) => dispatch(getStudyGroupWebinars(payload)),
  deleteWebinars: (ids, query) =>
    dispatch(showDeleteGroupWebinarsConfirmationModal(ids, query)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostWebinars);

class Webinar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { webinar, handleDelete, groupId, canUserCanEdit } = this.props;

    const { anchorEl } = this.state;

    const {
      id,
      start_date,
      webinar_title,
      cpd_status,
      cpd_points,
      cpd_quiz,
      sponsor,
      sponsors,
      status,
      int_cpd_points,
      ext_cpd_points,
      experts,
    } = webinar;

    const sponsorTitles = sponsors.length
      ? sponsors.map((_sponsor) => _sponsor.title || "N/A")
      : [(sponsor && sponsor.title) || "N/A"];

    const sponsorTitlesAsString = sponsorTitles.join(", ");

    const showCertificatesLink =
      status === "published" && cpd_status === "granted";

    return (
      <tr>
        <td>
          {start_date ? moment(start_date).format("D/M/YYYY") : "Record"}{" "}
          <span>
            {start_date
              ? moment(start_date).format("h:mm a").toUpperCase()
              : ""}
          </span>
        </td>
        <td>{webinar_title}</td>
        <td>
          {experts
            ? sortExpertsByNumeration(experts).map((expert, index) => (
                <p key={index}>
                  {expert.name && expert.name != null ? expert.name : ""}
                </p>
              ))
            : ""}
        </td>
        {cpd_status === CPD_STATUSES.granted && (
          <td>
            {(cpd_points == "internal" || cpd_points == "both") &&
              `${int_cpd_points} Int`}
            {cpd_points == "both" && ", "}
            {(cpd_points == "external" || cpd_points == "both") &&
              `${ext_cpd_points} Ext`}
          </td>
        )}
        {cpd_status !== CPD_STATUSES.granted && (
          <td>{validate.prettify(cpd_status)}</td>
        )}
        <td>{cpd_points}</td>
        <td>{cpd_quiz}</td>
        <td>{sponsorTitlesAsString}</td>
        <td>{status}</td>
        <td>
          {canUserCanEdit && (
            <div>
              <IconButton
                className="table_more"
                aria-label="More"
                aria-owns={anchorEl ? "long-menu" : null}
                aria-haspopup="true"
                onClick={this.handleClick}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
                PaperProps={{
                  style: {
                    width: 200,
                  },
                }}
              >
                <Link to={`/groups/${groupId}/webinars/${id}/edit`}>
                  <MenuItem>Edit</MenuItem>
                </Link>
                <MenuItem
                  onClick={() => {
                    this.handleClose();
                    handleDelete();
                  }}
                >
                  Delete
                </MenuItem>
                {showCertificatesLink && (
                  <MenuItem>
                    <Link
                      style={{ color: "black" }}
                      to={`/groups/${groupId}/webinars/${id}/certificates`}
                    >
                      Add certificates
                    </Link>
                  </MenuItem>
                )}
                <Link to={`/groups/${groupId}/webinars/${id}/users`}>
                  <MenuItem>Registered users</MenuItem>
                </Link>
              </Menu>
            </div>
          )}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostWebinars.jsx